import React, { FunctionComponent } from 'react';

import { PaymentConfirmationStep as CommonPaymentConfirmation } from 'scenes/common/components/Steps';
import { InsuranceName } from 'scenes/common/types';
import { HomeFullPageProps } from 'scenes/home/types';
import {
  getQuoteNumber,
  getPolicyStartDate,
  getReceiptNumber,
  getPaymentDate,
  getPaymentMethod,
  getPaymentFrequency,
  getContactEmailAddress,
  getFirstInstalment,
  getMonthlyInstalment,
} from 'scenes/home/selectors';

const PaymentConfirmationStep: FunctionComponent<HomeFullPageProps> = ({
  funnelState,
}) => (
  <CommonPaymentConfirmation
    quoteNumber={getQuoteNumber(funnelState)}
    receiptNumber={getReceiptNumber(funnelState)}
    contactEmail={getContactEmailAddress(funnelState)}
    policyStartDate={getPolicyStartDate(funnelState)}
    paymentDate={getPaymentDate(funnelState)}
    paymentMethod={getPaymentMethod(funnelState)}
    paymentFrequency={getPaymentFrequency(funnelState)}
    firstInstalment={getFirstInstalment(funnelState)}
    monthlyInstalment={getMonthlyInstalment(funnelState)}
    insuranceName={InsuranceName.Home}
  />
);

export default PaymentConfirmationStep;
